import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { NavigationBar } from '@cfm-media/pwa-ui-components';
import { Provider as StoreProvider } from '../core/store';

import { Store } from '../stores';
import { isAuthenticated } from './auth';
import { urls } from '../urls';

export function AppShell({ children, scrollOnNavigate = false }) {
  const [showSidebar, setShowSidebar] = useState(true);
  const location = useLocation();

  const appNavigation = {
    // prettier-ignore
    public: [
      { label: 'Login', href: urls.login, icon: 'icon-lock' },
      { label: 'Impressum', href: urls.imprint, icon: 'icon-documents' },
      { label: 'Datenschutz', href: urls.dataProtection, icon: 'icon-documents' },
      { label: 'AGB', href: urls.termsAndConditions, icon: 'icon-documents' },
    ],

    // prettier-ignore
    protected: [
      { label: 'Meine Reise', href: urls.home, icon: 'icon-home' },
      { label: 'Dokumente', href: urls.documents, icon: 'icon-documents' },
      { label: 'Kontakt', href: urls.contact, icon: 'icon-contact' },
      { label: 'Umgebung', href: urls.map, icon: 'icon-destination' },
      { label: 'Mehr', href: urls.sitemap, icon: 'icon-services' },
    ],
  };

  useEffect(() => {
    if (scrollOnNavigate) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <AppShellContext.Provider value={{ showSidebar, setShowSidebar }}>
      {showSidebar && (
        <NavigationBar
          navigationItems={
            isAuthenticated() ? appNavigation.protected : appNavigation.public
          }
          logo="/public/assets/images/logo-white.svg"
        />
      )}

      <StoreProvider value={Store}>
        {/**/}
        {children}
      </StoreProvider>
    </AppShellContext.Provider>
  );
}

const AppShellContext = createContext();

export function useSidebarVisibility(props) {
  const { setShowSidebar } = useContext(AppShellContext);

  useEffect(() => {
    setShowSidebar(!props?.hideSidebar);
  }, [props?.hideSidebar]);
}
